import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import NotFound from "./views/404.vue";
Vue.use(Router);
const router = new Router({
  mode: "history",
  base: "/",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "/",
          name: "main",
          meta: { title: "首页" },
          component: () => import("@/views/main/main")
        },
        {
          path: "/product",
          name: "product",
          meta: { title: "产品介绍" },
          component: () => import("@/views/product/product")
        },
        {
          path: "/product2",
          name: "product2",
          meta: { title: "产品介绍" },
          component: () => import("@/views/product/product2")
        },
        {
          path: "/product3",
          name: "product3",
          meta: { title: "产品介绍" },
          component: () => import("@/views/product/product3")
        },
        {
          path: "/product4",
          name: "product4",
          meta: { title: "产品介绍" },
          component: () => import("@/views/product/product4")
        },
        {
          path: "/service",
          name: "service",
          meta: { title: "服务承诺" },
          component: () => import("@/views/aboutUs/service")
        },
        {
          path: "/casedetail",
          name: "casedetail",
          meta: { title: "案例详情" },
          component: () => import("@/views/detail/caseDetail")
        },
        {
          path: "/casedetails",
          name: "casedetails",
          meta: { title: "案例详情1" },
          component: () => import("@/views/detail/caseDetails")
        },
        {
          path: "/casedetailss",
          name: "casedetailss",
          meta: { title: "案例详情2" },
          component: () => import("@/views/detail/caseDetailss")
        },
        {
          path: "/aboutus",
          name: "aboutus",
          meta: { title: "关于我们" },
          component: () => import("@/views/aboutUs/aboutUs")
        },
        {
          path: "/solution",
          name: "solution",
          meta: { title: "混合云方案" },
          component: () => import("@/views/solution/solution")
        },
        {
          path: "/solutegrop",
          name: "solutegrop",
          meta: { title: "私有方案" },
          component: () => import("@/views/solution/solutegrop")
        },
        {
          path: "/price",
          name: "price",
          meta: { title: "价格" },
          component: () => import("@/views/price/price")
        },
        {
          path: "/user",
          name: "user",
          meta: { title: "个人资料" },
          component: () => import("@/views/user/user")
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      meta: { title: "登录" },
      component: () => import("@/views/user/login")
    },
    {
      path: "/sign",
      name: "sign",
      meta: { title: "注册" },
      component: () => import("@/views/user/sign")
    },
    {
      path: "/forgetPsd",
      name: "forgetPsd",
      meta: { title: "忘记密码" },
      component: () => import("@/views/user/forgetPsd")
    },
    {
      path: "/clause",
      name: "clause",
      meta: { title: "服务条款" },
      component: () => import("@/views/agreement/clause")
    },
    {
      path: "/privacy",
      name: "privacy",
      meta: { title: "隐私政策" },
      component: () => import("@/views/agreement/privacy")
    },
    {
      path: "/news",
      name: "news",
      meta: { title: "新闻资讯" },
      component: () => import("@/views/news/news"),
      children: [
        {
          path: "/news",
          name: "newContent",
          meta: { title: "新闻资讯" },
          component: () => import("@/views/news/newContent")
        },
        {
          path: "/new",
          name: "new",
          meta: { title: "新闻" },
          component: () => import("@/views/news/new")
        }
      ]
    },
    {
      path: "/404",
      component: NotFound,
      name: ""
    }
  ]
});

export default router;
